import React from 'react';
import Paper, { PaperProps as MaterialPaperProps } from '@material-ui/core/Paper';
import Grid, { GridProps } from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import SupportTileBody from './SupportTileBody';
import CategoryHeader, { CategoryHeaderProps as LWTCategoryHeaderProps } from './CategoryHeader';

const CATEGORY_HEADER_HEIGHT = 25;
const BODY_FONT_SIZE = 16;
const CARD_HEIGHT = 180;
const VERTICAL_PADDING = 36;
const ASSUMED_MAX_TITLE_HEIGHT = 80;
export interface SupportTileProps extends GridProps {
  title?: string;
  CategoryHeaderProps?: LWTCategoryHeaderProps;
  children?: string;
  PaperProps?: MaterialPaperProps;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      paddingTop: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      overflowWrap: 'break-word',
      fontWeight: 700
    },
    overflow: {
      overflow: 'hidden',
      display: 'box',
      boxOrient: 'vertical'
    },
    container: {
      position: 'relative',
      height: '100%',
      maxHeight: '190px',

      '&::after': {
        content: "''",
        display: 'block',
        paddingBottom: '100%'
      }
    },
    paper: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      maxHeight: '190px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0 1px 8px 4px rgba(0, 0, 0, 0.20)',
        transform: 'scale(1.01, 1.01)'
      }
    }
  };
});
const SupportTile: React.FC<SupportTileProps> = ({
  children,
  onClick,
  title,
  CategoryHeaderProps,
  PaperProps,
  ...rest
}) => {
  const classes = useStyles();

  const [height, setHeight] = React.useState(0);
  const [width, setWidth] = React.useState(window.innerWidth);

  const contentRef: React.MutableRefObject<null | HTMLParagraphElement> = React.useRef(null);

  React.useEffect(() => {
    const titleHeight = contentRef?.current?.clientHeight || 0;
    const newHeight = Math.round(
      (CARD_HEIGHT -
        VERTICAL_PADDING -
        titleHeight -
        (CategoryHeaderProps ? CATEGORY_HEADER_HEIGHT : 0)) /
        BODY_FONT_SIZE
    );
    setHeight(titleHeight >= ASSUMED_MAX_TITLE_HEIGHT ? 0 : newHeight - 1);
  }, [width, contentRef, setHeight, CategoryHeaderProps]);

  React.useEffect(() => {
    function handleResize(): void {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);

    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, [setWidth]);

  return (
    <Grid item lg={3} md={4} sm={6} xs={12} {...rest}>
      <div className={classes.container}>
        <Paper className={classes.paper} onClick={onClick} {...PaperProps}>
          <div>
            {title && (
              <Typography variant="subtitle1" className={classes.title} ref={contentRef}>
                {title}
              </Typography>
            )}
            {CategoryHeaderProps && <CategoryHeader {...CategoryHeaderProps} />}
            {children && (
              <div
                className={classes.overflow}
                style={{
                  height: height === 0 ? height : 'auto',
                  WebkitLineClamp: height
                }}
              >
                <SupportTileBody>{children}</SupportTileBody>
              </div>
            )}
          </div>
        </Paper>
      </div>
    </Grid>
  );
};

export default SupportTile;
